import { styled } from '../../Styles/stitches.config'

export const StyledFlex = styled('div', {
    display: 'flex',
    variants: {
        isListContainer: {
            true: {
                p: '$3 $4',
                cursor: 'pointer',
                borderBottom: '1px solid $neutral200',
                '&:first-of-type': {
                    borderTop: '1px solid $neutral200',
                },
            },
        },
        direction: {
            column: {
                flexDirection: 'column',
            },
            'column-reverse': {
                flexDirection: 'column-reverse',
            },
            row: {
                flexDirection: 'row',
            },
            'row-reverse': {
                flexDirection: 'row-reverse',
            },
        },
        gap: {
            4: {
                gap: '$1',
            },
            8: {
                gap: '$2',
            },
            16: {
                gap: '$3',
            },
            32: {
                gap: 32,
            },
        },
        bgc: {
            black: { bgc: '$black' },
            error200: { bgc: '$error200' },
            error300: { bgc: '$error300' },
            error400: { bgc: '$error400' },
            error500: { bgc: '$error500' },
            error600: { bgc: '$error600' },
            neutral50: { bgc: '$neutral50' },
            neutral100: { bgc: '$neutral100' },
            neutral200: { bgc: '$neutral200' },
            neutral300: { bgc: '$neutral300' },
            neutral400: { bgc: '$neutral400' },
            neutral500: { bgc: '$neutral500' },
            neutral600: { bgc: '$neutral600' },
            neutral700: { bgc: '$neutral700' },
            neutral800: { bgc: '$neutral800' },
            neutral900: { bgc: '$neutral900' },
            primary200: { bgc: '$primary200' },
            primary300: { bgc: '$primary300' },
            primary400: { bgc: '$primary400' },
            primary500: { bgc: '$primary500' },
            primary600: { bgc: '$primary600' },
            secondary200: { bgc: '$secondary200' },
            secondary300: { bgc: '$secondary300' },
            secondary400: { bgc: '$secondary400' },
            secondary500: { bgc: '$secondary500' },
            secondary600: { bgc: '$secondary600' },
            white: { bgc: '$white' },
        },
        justifyContent: {
            'flex-start': {
                justifyContent: 'flex-start',
            },
            'flex-end': {
                justifyContent: 'flex-end',
            },
            center: {
                justifyContent: 'center',
            },
            'space-between': {
                justifyContent: 'space-between',
            },
            'space-around': {
                justifyContent: 'space-around',
            },
            'space-evenly': {
                justifyContent: 'space-evenly',
            },
        },
        alignItems: {
            auto: {
                alignItems: 'auto',
            },
            stretch: {
                alignItems: 'stretch',
            },
            'flex-start': {
                alignItems: 'flex-start',
            },
            'flex-end': {
                alignItems: 'flex-end',
            },
            center: {
                alignItems: 'center',
            },
            baseline: {
                alignItems: 'baseline',
            },
        },
        alignSelf: {
            auto: {
                alignItems: 'auto',
            },
            stretch: {
                alignItems: 'stretch',
            },
            'flex-start': {
                alignItems: 'flex-start',
            },
            'flex-end': {
                alignItems: 'flex-end',
            },
            center: {
                alignItems: 'center',
            },
            baseline: {
                alignItems: 'baseline',
            },
        },
        alignContent: {
            'flex-start': {
                alignContent: 'flex-start',
            },
            'flex-end': {
                alignContent: 'flex-end',
            },
            center: {
                alignContent: 'center',
            },
            'space-between': {
                alignContent: 'space-between',
            },
            'space-around': {
                alignContent: 'space-around',
            },
            stretch: {
                alignContent: 'stretch',
            },
        },
        justifyItems: {
            auto: {
                justifyItems: 'auto',
            },
            normal: {
                justifyItems: 'normal',
            },
            stretch: {
                justifyItems: 'stretch',
            },
            baseline: {
                justifyItems: 'baseline',
            },
            'first baseline': {
                justifyItems: 'first baseline',
            },
            'last baseline': {
                justifyItems: 'last baseline',
            },
            center: {
                justifyItems: 'center',
            },
            start: {
                justifyItems: 'start',
            },
            end: {
                justifyItems: 'end',
            },
            'flex-start': {
                justifyItems: 'flex-start',
            },
            'flex-end': {
                justifyItems: 'flex-end',
            },
            'self-start': {
                justifyItems: 'self-start',
            },
            'self-end': {
                justifyItems: 'self-end',
            },
            left: {
                justifyItems: 'left',
            },
            right: {
                justifyItems: 'right',
            },
            safe: {
                justifyItems: 'safe',
            },
            unsafe: {
                justifyItems: 'unsafe',
            },
            'legacy center': {
                justifyItems: 'legacy center',
            },
            'legacy left': {
                justifyItems: 'legacy left',
            },
            'legacy right': {
                justifyItems: 'legacy right',
            },
            inherit: {
                justifyItems: 'inherit',
            },
            initial: {
                justifyItems: 'initial',
            },
            unset: {
                justifyItems: 'unset',
            },
        },
        placeItems: {
            center: {
                placeItems: 'center',
            },
            'normal start': {
                placeItems: 'normal start',
            },
            'center normal': {
                placeItems: 'center normal',
            },
            'start legacy': {
                placeItems: 'start legacy',
            },
            'end normal': {
                placeItems: 'end normal',
            },
            'self-start legacy': {
                placeItems: 'self-start legacy',
            },
            'self-end normal': {
                placeItems: 'self-end normal',
            },
            'flex-start legacy': {
                placeItems: 'flex-start legacy',
            },
            'flex-end normal': {
                placeItems: 'flex-end normal',
            },
            'left legacy': {
                placeItems: 'left legacy',
            },
            'right normal': {
                placeItems: 'right normal',
            },
            'baseline normal': {
                placeItems: 'baseline normal',
            },
            'first baseline legacy': {
                placeItems: 'first baseline legacy',
            },
            'last baseline normal': {
                placeItems: 'last baseline normal',
            },
            'stretch legacy': {
                placeItems: 'stretch legacy',
            },
            inherit: {
                placeItems: 'inherit',
            },
            initial: {
                placeItems: 'initial',
            },
            revert: {
                placeItems: 'revert',
            },
            unset: {
                placeItems: 'unset',
            },
        },
        placeContent: {
            center: {
                placeContent: 'center',
            },
            'normal start': {
                placeContent: 'normal start',
            },
            'center normal': {
                placeContent: 'center normal',
            },
            'start legacy': {
                placeContent: 'start legacy',
            },
            'end normal': {
                placeContent: 'end normal',
            },
            'self-start legacy': {
                placeContent: 'self-start legacy',
            },
            'self-end normal': {
                placeContent: 'self-end normal',
            },
            'flex-start legacy': {
                placeContent: 'flex-start legacy',
            },
            'flex-end normal': {
                placeContent: 'flex-end normal',
            },
            'left legacy': {
                placeContent: 'left legacy',
            },
            'right normal': {
                placeContent: 'right normal',
            },
            'baseline normal': {
                placeContent: 'baseline normal',
            },
            'first baseline legacy': {
                placeContent: 'first baseline legacy',
            },
            'last baseline normal': {
                placeContent: 'last baseline normal',
            },
            'stretch legacy': {
                placeContent: 'stretch legacy',
            },
            inherit: {
                placeContent: 'inherit',
            },
            initial: {
                placeContent: 'initial',
            },
            revert: {
                placeContent: 'revert',
            },
            unset: {
                placeContent: 'unset',
            },
        },
    },
})
